import React, { Component } from 'react';
import Auth from 'j-toker';

import 'components/tenant_app/tenant_showing.css';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Icon, { LoadingOutlined } from '@ant-design/icons';

import { AccentColor } from 'helpers/AccentColorHelper';
import RentersInsuranceUploader from './RentersInsuranceUploader';
import { NueraDialog, redirectToNuera } from 'components/tenant_app/components/InsuranceDialog';

import UploadIcon from '@material-ui/icons/CloudUploadTwoTone';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { getTranslatedString } from 'helpers/i18n';
import { apiGet } from 'helpers/ApiHelper';
import { featureEnabled } from 'helpers/ToggleBot';

import withMobileDialog from '@material-ui/core/withMobileDialog';

const DocumentUploadTodoDialog = class DocumentUploadTodo extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      nueraDialogOpen: false,
      insuranceUploaderDialogOpen: false,
      loadingPurchase: false,
    };
  }

  toggleInsuranceUploaderDialog = () => {
    this.setState({ insuranceUploaderDialogOpen: !this.state.insuranceUploaderDialogOpen });
  };

  toggleNueraDialog = () => {
    this.setState({
      nueraDialogOpen: !this.state.nueraDialogOpen,
    });
  };

  redirectPurchaseInsurance = async () => {
    this.setState({ loadingPurchase: true });
    if (featureEnabled('apollo_insurance')) {
      try {
        const { provider_url } = await apiGet(
          `${Auth.getApiUrl()}/leads/insurance/provider_redirect`
        );

        window.open(provider_url, '_blank');
      } catch (error) {
        this.props.showFailure(error);
      }
    } else {
      // TODO: remove when apollo insurance is confirmed as both nuera and apollo will use this backend
      //       endpoint above to fetch redirect
      redirectToNuera({
        leaseStartDate: this.props.leaseStartDate,
        birthday: this.props.tenantOverview.birthday,
        email: this.props.tenantOverview.email,
        phoneNumber: this.props.tenantOverview.phone_number,
        tenantId: this.props.tenantOverview.cotenant_id,
        ...this.props.address,
      });
    }
    this.setState({ loadingPurchase: false });
  };

  render() {
    return (
      <div>
        <NueraDialog
          isOpen={this.state.nueraDialogOpen}
          toggleDialog={this.toggleNueraDialog}
          {...this.props.address}
          leaseStartDate={this.props.leaseStartDate}
          birthday={this.props.tenantOverview.birthday}
          email={this.props.tenantOverview.email}
          phoneNumber={this.props.tenantOverview.phone_number}
          tenantId={this.props.tenantOverview.cotenant_id}
          fullScreen={this.props.fullScreen}
        />
        <RentersInsuranceUploader
          dialogOpen={this.state.insuranceUploaderDialogOpen}
          toggleDialog={this.toggleInsuranceUploaderDialog}
          onSubmit={this.props.createTenantDocument}
        />
        <Dialog
          disableBackdropClick
          open={this.props.isOpen}
          onClose={this.props.toggleDialog}
          classes={{ paper: 'form-dialog' }}
          fullScreen={this.props.fullScreen}
        >
          <DialogTitle id="payment-details-dialog" style={{ paddingBottom: '10px' }}>
            <h3 style={{ margin: '10px 0 5px', textAlign: 'center' }}>
              {getTranslatedString('tenantPortal.documentUploadTodoDialog.rentersInsurance')}
            </h3>
            <h5 style={{ fontFamily: 'Circular' }}>
              {getTranslatedString('tenantPortal.documentUploadTodoDialog.weHavePartnered')}
            </h5>
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                borderTop: `5px solid ${AccentColor()}`,
                paddingTop: '20px',
              }}
            >
              <div className="row" style={{ display: 'flex' }}>
                <div
                  className="col-xs-6"
                  id="hover-select"
                  style={{ marginTop: '15px' }}
                  onClick={this.toggleInsuranceUploaderDialog}
                  aria-label={getTranslatedString(
                    'tenantPortal.documentUploadTodoDialog.uploadInsurance'
                  )}
                  tabIndex="1"
                >
                  <div
                    style={{
                      width: '85px',
                      height: '65px',
                      margin: 'auto',
                      textAlign: 'center',
                      cursor: 'pointer',
                      paddingTop: '9px',
                    }}
                  >
                    <UploadIcon style={{ color: AccentColor(), height: '55px', width: '55px' }} />
                  </div>
                  <p
                    style={{
                      textAlign: 'center',
                      fontFamily: 'Circular-Bold',
                      fontSize: '16px',
                    }}
                  >
                    {getTranslatedString('tenantPortal.documentUploadTodoDialog.uploadInsurance')}
                  </p>
                </div>
                <div
                  className="col-xs-6"
                  id="hover-select"
                  style={{ marginTop: '15px' }}
                  onClick={this.redirectPurchaseInsurance}
                  aria-label={getTranslatedString(
                    'tenantPortal.documentUploadTodoDialog.purchaseInsurance'
                  )}
                  tabIndex="1"
                >
                  <div
                    style={{
                      width: '85px',
                      height: '65px',
                      margin: 'auto',
                      textAlign: 'center',
                      cursor: 'pointer',
                      paddingTop: '10px',
                      paddingLeft: '3px',
                    }}
                  >
                    <ShoppingCartIcon
                      style={{ color: AccentColor(), height: '46px', width: '55px' }}
                    />
                  </div>
                  <p
                    style={{
                      textAlign: 'center',
                      fontFamily: 'Circular-Bold',
                      fontSize: '16px',
                    }}
                  >
                    {this.state.loadingPurchase && <Icon component={LoadingOutlined} spin />}{' '}
                    {getTranslatedString('tenantPortal.documentUploadTodoDialog.purchaseInsurance')}
                  </p>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.props.toggleDialog}
              id="close-button"
              style={{ color: AccentColor() }}
              aria-label={getTranslatedString('close')}
              tabIndex="1"
            >
              {getTranslatedString('close')}
            </FlatButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
};

export default withMobileDialog()(DocumentUploadTodoDialog);
